import { subDays, subMonths, subYears } from "date-fns";

export const timeseriesEndpoints = [
  "resops-ts-stagecoach15-min",
  "resops-ts-stagecoach-hourly",
  "resops-ts-stagecoach-daily",
];

export const optionsEndpoints = [
  "resops-ts-stagecoach-left-axis-options",
  "resops-ts-stagecoach-right-axis-options",
  "resops-ts-stagecoach-timestep-options",
];

export const seriesEndpoints = [
  "resops-ts-stagecoach-left-axis-series",
  "resops-ts-stagecoach-right-axis-series",
];

export const TIMESTEP_OPTIONS = [
  { label: "Hourly", value: "resops-ts-stagecoach-hourly", defaultDays: 92 },
  { label: "Daily", value: "resops-ts-stagecoach-daily", defaultDays: 366 },
];

const currentYear = new Date().getFullYear();

const makeSeasonOption = (year) => ({
  label: `${year} Season`,
  getStartDate: () => new Date(year, 4, 1),
  getEndDate: () => new Date(year, 9, 31),
  disableFor: ["resops-ts-stagecoach-hourly"],
});

export const QUICKSET_OPTIONS = [
  {
    label: "Last 10 Days",
    getStartDate: () => subDays(new Date(), 10),
    disableFor: [],
  },
  {
    label: "Last 30 Days",
    getStartDate: () => subDays(new Date(), 30),
    disableFor: [],
  },
  {
    label: "Last 3 Months",
    getStartDate: () => subMonths(new Date(), 3),
    disableFor: [],
  },
  {
    label: "Last 6 Months",
    getStartDate: () => subMonths(new Date(), 6),
    disableFor: ["resops-ts-stagecoach-hourly"],
  },
  {
    label: "Last 1 Year",
    getStartDate: () => subYears(new Date(), 1),
    disableFor: ["resops-ts-stagecoach-hourly"],
  },
  makeSeasonOption(currentYear),
  makeSeasonOption(currentYear - 1),
  makeSeasonOption(currentYear - 2),
  makeSeasonOption(currentYear - 3),
];
